<template>
  <div class="align-self-end mt-50 ml-20">
    <!-- Модальное окно с анкетой -->
    <el-dialog
      class="questionnaire-dialog"
      title="Заполните анкету"
      :visible.sync="showQuestionnaire"
      :show-close="false"
      v-if="project"
    >
      <div @click="showQuestionnaire = false" class="el-dialog__close"></div>
      <questionnaire :project="project"/>
    </el-dialog>
    
    <button v-if="!course.enroll" @click="enroll()" class="btn btn-black">
      <spin-load :show="loading"  />
    </button>
    <button v-else @click="unEnroll()" class="btn btn-black">
      <spin-load :show="loading">Отписаться</spin-load>
    </button>
  </div>
</template>

<script>
import {eventBus} from "../../main";
import {mapGetters, mapMutations} from "vuex";
import TYPES from "../../../../src/components/User/actionsTypes";
import actionsMixin from "../../mixin/actionsMixin";
import SpinLoad from "../SpinLoad.vue";
import Questionnaire from "../Questionnaire.vue";

export default {
  name: "CourseEnrollButton",
  components: {SpinLoad, Questionnaire},
  mixins: [actionsMixin],
  data() {
    return {
      loading: false,
      project: null,
      showQuestionnaire: false
    }
  },
  mounted() {
    // Слушаем событие завершения заполнения анкеты
    eventBus.$on('enroll', () => {
      this.enroll(false);
    });

    // Загружаем проект для курса
    this.axios.get('projects', {
      params: {
        courses: [this.course.id]
      }
    }).then(res => {
      console.log('Projects response:', res.data);
      if(res.data.length) {
        this.project = res.data[0];
        console.log('Project loaded:', this.project);
      }
    }).catch(error => {
      console.error('Error loading projects:', error);
    });

    // Проверяем, нужно ли автоматически записаться на курс
    if(localStorage.getItem('has-enroll')) {
      this.enroll(false)
      localStorage.removeItem('has-enroll')
    }
  },
  beforeDestroy() {
    eventBus.$off('enroll');
  },
  methods: {
    async enroll(withMsg = true) {
      if(!this.$auth.check()) {
        // Определяем, мобильное ли устройство
        const isMobile = window.innerWidth <= 1024;
        eventBus.$emit(isMobile ? 'show:login-mobile' : 'show:login')
      } else {
        // Проверяем, нужно ли показать анкету
        if(withMsg && this.project && this.project.profileFields && this.project.profileFields.length) {
          this.showQuestionnaire = true;
          return;
        }

        this.loading = true
        try {
          let enroll = await this.axios.post(`enrollments/${this.course.id}`, {'isActive': true})
          
          // Проверяем, есть ли ссылка на оплату
          if (enroll.data.paymentLink) {
            window.location = enroll.data.paymentLink;
            return;
          }

          if (enroll.status === 201) {
            // Обновляем данные курса
            const courseResponse = await this.axios.get(`courses/${this.course.id}`);
            const updatedCourse = { ...courseResponse.data, enroll: enroll.data };
            this.setCourse(updatedCourse);

            // Проверяем, что пользователь существует перед добавлением действия
            if (this.$auth.user()) {
              this.addAction(TYPES.COURSE_ENROLL_TYPE, this.course.name);
            }
            eventBus.$emit('enroll:course');
            this.showQuestionnaire = false;
          }
        } catch (error) {
          console.error('Ошибка при записи на курс:', error);
        } finally {
          this.loading = false
        }
      }
    },
    async unEnroll() {
      this.loading = true
      await this.axios.post(`enrollments/${this.course.id}`, {'isActive': false})
      this.addAction(TYPES.COURSE_UN_ENROLL_TYPE, this.course.name)
      this.loading = false
      this.setCourse({...this.course, enroll: null})
    },
    ...mapMutations(['setCourse'])
  },
  computed: {
    ...mapGetters(['course'])
  }
}
</script>

<style lang="scss">
.questionnaire-dialog {
  * {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  *:before,
  *:after {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
  }
  
}
</style>